import { render, staticRenderFns } from "./pc-feedback.vue?vue&type=template&id=bbaf031a&scoped=true"
import script from "./pc-feedback.vue?vue&type=script&lang=js"
export * from "./pc-feedback.vue?vue&type=script&lang=js"
import style0 from "./pc-feedback.vue?vue&type=style&index=0&id=bbaf031a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaf031a",
  null
  
)

export default component.exports